<template>
  <div class="feedback" @click="createWaveSurfer()">
    <div class="user">
      <div class="image">
        <img src="../assets/IngoSchimpff.jpg" />
      </div>
    </div>
    <div class="offer">
      <div class="details">
        <div class="track-details">
          <span class="track-title">
            First Aim Cover
          </span>
          <span class="user-name">
            by Isak Johannesson
          </span>
        </div>
        <div class="offer-details">
          <span class="price">
            $300
          </span>
          <span class="status">
            - Expires in 7 days
          </span>
        </div>
      </div>
      <div class="track">
        <div class="player">
          <div class="controls">
            <div @click="wavesurfer.playPause()" class="play">
              <img src="../assets/icons/Track-Play.svg" />
            </div>
          </div>
          <div class="info">
            <span>{{ current }}</span>
          </div>
          <div class="waveform-container">
            <div id="waveform2"></div>
            <!-- <div :id="waveformId"></div> -->
          </div>
          <div class="info">
            <span>{{ duration }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="description">
      <p class="text">
        You requested feedback from <span>Banana Boy</span> for $300 that
        expires in 7 days.
      </p>
    </div>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
export default {
  data() {
    return {
      id: "",
      wavesurfer: null,
      track:
        "https://archive.org/download/cd_chop-suey_system-of-a-down/disc1/01.%20System%20of%20a%20Down%20-%20Chop%20Suey%21_sample.mp3",
      currentSeconds: 0,
      durationSeconds: null,
      trackLoaded: false
    };
  },
  async mounted() {
    if (!this.wavesurfer) this.createWaveSurfer();
  },
  name: "TrackFeedback",
  components: {},
  computed: {
    waveformId() {
      return `waveform${this.id}`;
    },
    current: function() {
      if (this.trackLoaded) {
        return this.calculateDuration(this.currentSeconds);
      }
      return "0:00";
    },
    duration: function() {
      if (this.trackLoaded) {
        return this.calculateDuration(this.durationSeconds);
      }
      return "0:30";
    }
  },
  methods: {
    calculateDuration(seconds) {
      let sec = (seconds % 60).toFixed(0);
      const min = parseInt(seconds / 60);
      if (sec.toString().length == 1) {
        sec = "0" + sec;
      }
      return min + ":" + sec;
    },
    createWaveSurfer() {
      if (this.wavesurfer) return;
      this.id = Date.now();
      this.wavesurfer = WaveSurfer.create({
        // container: `#waveform${this.Id}`,
        container: `#waveform2`,
        waveColor: "#EDEDED",
        progressColor: "#FF035A",
        cursorColor: "#3B3B3B",
        barHeight: 1,
        barMinHeight: 1,
        barWidth: 3,
        barRadius: 3,
        cursorWidth: 1,
        height: 40,
        barGap: 3
      });
      this.wavesurfer.load(this.track);

      this.wavesurfer.on("ready", () => {
        this.trackLoaded = true;
        this.durationSeconds = this.wavesurfer.getDuration();
      });

      this.wavesurfer.on("audioprocess", () => {
        this.currentSeconds = this.wavesurfer.getCurrentTime();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";
.feedback {
  display: flex;
  background: $bg;
  margin-bottom: 40px;
  flex-wrap: wrap;
  .user {
    display: flex;
    flex-direction: column;
    align-items: center;
    .image {
      width: 108px;
      height: 108px;
      overflow: hidden;
      border-radius: 50%;
      img {
        object-fit: cover;
      }
    }
  }
  .offer {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    .details {
      width: 100%;
      display: flex;
      .track-details {
        display: flex;
        flex-direction: column;
        flex: 1;
        .track-title {
          @include menu-bold();
        }
        .user-name {
          @include body-light(16px, 24px);
          color: $text-additional;
          margin-top: 8px;
        }
      }
      .offer-details {
        @include body-light();
        .price {
          font-weight: 700;
          color: $accent;
        }
      }
    }
    .track {
      width: 100%;
      margin-top: 16px;
      .player {
        display: flex;
        align-items: baseline;
        .controls {
          width: 38px;
          margin-right: 8px;
          .play {
            img {
              width: 38px;
              height: 38px;
            }
          }
        }
        .info {
          width: 24px;
          span {
            font-size: 12px;
            line-height: 14px;
            letter-spacing: -0.165px;
            color: $text-additional;
          }
        }
        .waveform-container {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          #waveform2 {
            width: 100%;
            margin: 0 16px;
            height: 40px;
            overflow-y: hidden;
          }
          .comments {
            display: flex;
            width: 100%;
            padding: 0 16px;
            margin-top: 4px;
            position: relative;
            .comment {
              display: flex;
              flex-direction: column;
              align-items: center;
              position: absolute;
              .image {
                width: 18px;
                height: 18px;
                overflow: hidden;
                border-radius: 50%;
                img {
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
    }
  }
  .description {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 32px;
    .text {
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: -0.22px;
      color: $text-additional;
      span {
        color: $accent;
      }
    }
  }
}
</style>
